import modelBaseV2 from "../model-base-v2.model";
import modelBase from "../model-base.model";

var userMapModel = {
  getAll: (successCallBack, failureCallBack) => {
    modelBase.get(successCallBack, failureCallBack, '/api/usermap');
  },
  getByCountry: (successCallBack, failureCallBack, countryCode) => {
    modelBase.get(successCallBack, failureCallBack, `/api/usermap/${countryCode}`);
  },
  getByCountryType: (successCallBack, failureCallBack, countryCode, mapType) => {
    modelBase.get(successCallBack, failureCallBack, `/api/usermap/${countryCode}/${mapType}`);
  },
  getByUser: (successCallBack, failureCallBack, countryCode, mapType, userId) => {
    modelBase.get(successCallBack, failureCallBack, `/api/usermap/${countryCode}/${mapType}/${userId}`);
  },
  getByUserV2: (countryCode, mapType, userId) => {
    return modelBaseV2.get(`/api/usermap/${countryCode}/${mapType}/${userId}`);
  },
  removeCountry: (successCallBack, failureCallBack, countryCode, userId) => {
    modelBase.post(successCallBack, failureCallBack, `/api/usermap/delete/${countryCode}/${userId}`);
  },
  getManagedSite: (successCallBack, failureCallBack, countryCode, userId) => {
    modelBase.post(successCallBack, failureCallBack, `api/site/managed/${countryCode}/${userId}`);
  },
}

export default userMapModel;
